import { render } from "./History.vue?vue&type=template&id=0e5698d4&scoped=true&ts=true"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"

import "./History.vue?vue&type=style&index=0&id=0e5698d4&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5698d4"]])

export default __exports__